import { FreeShippingItemListResponseDto } from '@tiendanube/common';
import { useListDesktop } from 'App/hooks';
import { useListFilters } from 'commons/hooks';
import { FreeShippingEndpoints } from 'domains/Marketing/FreeShipping/freeShippingApi';

const DEFAULT_FILTERS = { page: 1 };

export function useFreeShippingDesktop() {
  const { filters, changeFilters } = useListFilters(
    'free-shipping',
    DEFAULT_FILTERS,
  );

  const changePage = (page: number) => {
    changeFilters({ ...filters, page });
  };

  const result = useListDesktop<FreeShippingItemListResponseDto>({
    filters: { ...filters, perPage: '20' },
    endpoint: FreeShippingEndpoints.getFreeShippingsList,
  });

  return { ...result, changePage, filters };
}
